import {
  ComponentRef,
  Directive,
  Input,
  OnInit,
  ViewContainerRef
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../field.interface';
import { InputComponent } from '../input/input.component';
import { ButtonComponent } from '../button/button.component';
import { SelectComponent } from '../select/select.component';
import { DateComponent } from '../date/date.component';
import { RadiobuttonComponent } from '../radiobutton/radiobutton.component';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { TextAreaComponent } from '../textarea/textarea.component';
import { MultiSelectComponent } from '../multiselect/multiselect.component';
import { KendoFileUploadComponent } from '../kendofileupload/kendofileupload.component';

const componentMapper = {
  input: InputComponent,
  button: ButtonComponent,
  select: SelectComponent,
  multiselect: MultiSelectComponent,
  date: DateComponent,
  radiobutton: RadiobuttonComponent,
  checkbox: CheckboxComponent,
  textarea: TextAreaComponent,
  kendofileupload: KendoFileUploadComponent
};

@Directive({
    selector: '[dynamicField]',
    standalone: false
})
export class DynamicFieldDirective implements OnInit {
  @Input() field: FieldConfig;
  @Input() group: UntypedFormGroup;
  componentRef: any;
  constructor(
    private container: ViewContainerRef
  ) { }

  ngOnInit() {
    this.componentRef = this.container.createComponent(
      componentMapper[this.field.type]
    );
    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;
  }
}
